import React from 'react';

import {Skeleton, Stack, Typography} from '@mui/material';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {StyledSkeleton} from './styles';
import {getItemsPerSlide} from '../utils/formatSlides';

const {title} = translations['pt-br'].privateFlow.perks.lifeplace.products;

export const LifeplaceProductsLoading = () => {
	const {isMobile, isTablet, betweenMobileAndDesktop} = useMediaQueries();

	const itemsPerSlide = getItemsPerSlide(isMobile, betweenMobileAndDesktop);

	return (
		<Stack gap={2}>
			<Typography fontSize={20} fontWeight={600} color="text.primary">
				{title}
			</Typography>

			<Stack direction="row" gap={isTablet ? 1 : 3} width="100%">
				{Array.from({length: itemsPerSlide}).map((_, index) => (
					<StyledSkeleton key={index} variant="rectangular" />
				))}
			</Stack>
			<Skeleton variant="rectangular" width="100%" height={32} sx={{borderRadius: 1}} />
		</Stack>
	);
};
